import React from 'react';
import './projects.css';
import { Route, Link, withRouter } from 'react-router-dom';
import Project from './project.jsx';
import lollygag from '../images/lollygag.png';
import songcabin from '../images/songcabin.png';

const Projects = (props) => {
  const projects = [{title: "SongCabin", link: "songcabin",
    live: "https://songcabin.herokuapp.com/",
    git: "https://github.com/aschneit/SongCabin",
    desc: "A single-page, BandCamp-inspired app for uploading and playing music (React, Redux, Rails)",
    image: songcabin},
  {title: "Lollygag Looper", link: "lollygag",
    live: "http://aschneit.com/Lollygag-Looper/",
    git: "https://github.com/aschneit/Lollygag-Looper",
    desc: "A music-looping app utilizing the Tone.js library (JavaScript)",
    image: lollygag},
  {title: "AskDOM", link: "askdom",
    live: "http://aschneit.com/HopsToIt/",
    git: "https://github.com/aschneit/AskDom",
    desc: 'A jQuery-inspired JavaScript library enabling easy manipulation of the DOM. (Live link launches demo site using the library)',
    image: null}];

  return (
    <div className="projects-main">
      <ul className="projects-links">
        {projects.map(project => {
          return <li className={props.location.pathname === `/projects/${project.link}` ? "selected" : "unselected" }>
            <Link to={`/projects/${project.link}`}>{project.title}</Link></li>;
        })}
      </ul>
      <div className="projects-full">
        {projects.map(project => {
          return <Route path={`/projects/${project.link}`}
            component={() => <Project
              title={project.title}
              live={project.live}
              git={project.git}
              desc={project.desc}
              image={project.image}
              />}/>;
        })}
      </div>
    </div>
  );
};

export default withRouter(Projects);



// WEBPACK FOOTER //
// ./src/pages/projects.jsx